import { nonEmptyStringValidator, translatableValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const customFilmActionValidator = Validator.object({
    title: translatableValidator,
    message: Validator.optional(translatableValidator),
    iconName: Validator.optional(nonEmptyStringValidator),
    href: Validator.optional(nonEmptyStringValidator),
    onClick: Validator.optional(Validator.fn())
});
